import React from "react"
import Image from "../UI/Image/Image"
import PropTypes from "prop-types"
import { get } from "../../helpers/utils"
import Link from "../UI/Link/Link"
import { imageConstants } from "../../constants/image.constants"
import * as styles from "./SocialLinks-tw-styles"

const SocialLinks = props => {
  const { linkCollection, variant } = props
  const logoLinks =
    linkCollection && get(linkCollection, "items", "title", "ariaLabel", [])
  const printIcon = imageConstants.print
  const style = styles[variant] || styles.defaultStyle

  return (
    <div className={style?.socialWpr}>
      {logoLinks?.map((item, index) => (
        <Link
          ariaLabel={item?.ariaLabel}
          images={item?.images}
          url={item?.url}
          className={style?.socialLink}
          key={index}
        />
      ))}
      {props?.isBreadcrumb && (
        <div aria-label="print" role="button" onClick={() => window.print()}>
          <Image contentfulImage={printIcon} alt={"print page"} />
        </div>
      )}
    </div>
  )
}

SocialLinks.propTypes = {
  linkCollection: PropTypes.object,
  variant: PropTypes.string,
  isBreadcrumb: PropTypes.bool,
}

export default SocialLinks
